import axios from 'axios';
const dom = document.querySelector('link[rel="https://api.w.org/"]'), promises = {};
class ClientObject {
    constructor() {
        var _a;
        this.client = axios.create({
            baseURL: dom ? dom.getAttribute('href') || '/rest/' : '/rest/',
            timeout: 10000,
            headers: {
                'X-WP-Nonce': ((_a = window.pwjObj) === null || _a === void 0 ? void 0 : _a.token) || ''
            }
        });
    }
    request(method, url) {
        return this.client.request({
            url: url,
            method: method,
        });
    }
    get(url) {
        if (promises[url] instanceof Promise) {
            return promises[url];
        }
        return promises[url] = this.client.get(url)
            .finally(() => delete (promises[url]));
    }
    put(url, data) {
        return this.client.put(url, data);
    }
    post(url, data) {
        return this.client.post(url, data);
    }
    delete(url) {
        return this.client.delete(url);
    }
}
export default ClientObject;
